import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';

import { AccountTicketsFacade } from '@ridango/components';
import { LocalWebTicket, UserTicketActionsEnum, UserTicketActionCarrier } from '@ridango/core';

import { Observable } from 'rxjs';

@Component({
    selector: 'rwidget-account-email-tickets',
    templateUrl: './account-email-tickets.component.html',
    styleUrls: ['./account-email-tickets.component.scss']
})
export class AccountEmailTicketsComponent implements OnInit {
    private qrModalDialog: MatDialogRef<any, any>;
    @ViewChild('qrModal', { read: TemplateRef, static: true }) qrModalRef: TemplateRef<any>;
    accountTicketsLoaded$: Observable<boolean> = this.accountTicketsFacade.loaded$;
    tickets$: Observable<any> = this.accountTicketsFacade.accountEmailTickets$;
    selectedTicket$: Observable<any> = this.accountTicketsFacade.selectedTicket$;

    locale = this.translate.currentLang;
    constructor(
        private translate: TranslateService,
        private accountTicketsFacade: AccountTicketsFacade,
        private dialog: MatDialog
    ) {}

    ngOnInit() {
        this.accountTicketsFacade.fetchAccountTickets();
    }

    ticketAction(action: UserTicketActionCarrier) {
        switch (action.action.type) {
            case UserTicketActionsEnum.QR:
                // this.selectedTicketDepartureTime = this.getFormattedDateWithTime(action.ticket);
                this.displayQR(action.ticket);
                return;
            case UserTicketActionsEnum.REFUND:
                // this.refundTicket(action.ticket);
                return;
        }
    }

    displayQR(ticket: LocalWebTicket) {
        this.accountTicketsFacade.setSelectedTicket(ticket);
        this.qrModalDialog = this.dialog.open(this.qrModalRef, {
            autoFocus: true
        });
    }

    closeQrModal() {
        this.qrModalDialog.close();
    }
}
